const sharedData = {
  showShareGuideFlag: false,
  showCampaignCreatedFlag: false,
};

export { sharedData };



// WEBPACK FOOTER //
// ./src/services/vars.ts